import { ChatProviderType } from '../../../domain/chat/models/ChatProviderType';
import { IProviderServices } from '../interfaces/IProviderServices';


export class ProviderServicesRouter {
    private readonly providerServicesMap: Map<ChatProviderType, IProviderServices>;

        constructor(providerServices: IProviderServices[]) {
        this.providerServicesMap = new Map(
            providerServices.map((services) => [services.providerType, services]),
        );

    }

    public getProviderServices(providerType: ChatProviderType): IProviderServices {
        const providerServices = this.providerServicesMap.get(providerType);

        if (!providerServices) {
            throw new Error(`Provider services not configured for provider type: ${providerType}`);
        }

        return providerServices;
    }

    public getAllProviderServices(): IProviderServices[] {
        return Array.from(this.providerServicesMap.values());
    }
}

